(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDCampaignQuestionnaireSectionListEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'externalParty', 'campaign', 'questionnaire'];

    function Controller($scope, $state, externalParty, campaign, questionnaire) {
        $scope.externalParty = externalParty;
        $scope.campaign = campaign;
        $scope.questionnaire = questionnaire;

        $scope.goToExternalParty = function () {
            $state.go('odd.externalPartyEdit');
        };

        $scope.goToCampaign = function () {
            $state.go('odd.externalPartyEdit.campaign');
        };

        $scope.goToQuestionnaire = function () {
            $state.go('odd.externalPartyEdit.campaign.questionnaire', {}, { reload: true });
        };
    }
})();